import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import TailwindProvider from "../WebSiteApp/TailwindProvider";

// Pages publiques - Tailwind chargé via TailwindProvider
const WebSiteApp = lazy(() => import("../WebSiteApp"));

// Pages admin - Bootstrap isolé via AdminLayout avec wrapper .bs-wrapper
const AdminLayout = lazy(() => import("../WebSiteApp/AdminLayout"));
const LoginAdmin = lazy(() => import("../WebSiteApp/LoginAdmin"));
const Dashboard = lazy(() => import("../WebSiteApp/Dashboard"));

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    Chargement...
  </div>
);

const App = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Routes admin - Bootstrap isolé via AdminLayout avec .bs-wrapper */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<LoginAdmin />} />
          <Route path="dashboard" element={<Dashboard />} />
        </Route>

        {/* Routes publiques - Tailwind chargé via TailwindProvider */}
        <Route
          path="/*"
          element={
            <TailwindProvider>
              <WebSiteApp />
            </TailwindProvider>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default App;
